import * as React from 'react';
import * as MuiCore from '@mui/material';
import { Divider, Checkbox } from '@mui/material';
import { useLanguageLocale } from '../../hooks/language-locale-hooks';

export interface Props {
    disabled?: boolean;
    isLoading?: boolean;
    records: any[];
    changeHandler: (values: any[]) => void;
    selectedValues?: any[];
    showSelectedCount?: boolean
}

export function FilterDropdown(props: Props) {

    const { disabled = false, isLoading = false, records, changeHandler, selectedValues = [], showSelectedCount = false } = props;

    const { t } = useLanguageLocale();

    const [isOpen, setIsOpen] = React.useState(false);
    const [selected, setSelected] = React.useState<any[]>([]);

    const isAllSelected = selected.length === records.length;

    const handleChange = (event: MuiCore.SelectChangeEvent<typeof selected>) => {
        const value = event.target.value;

        let data: any[] = [];

        if (value.includes('All')) {
            const allSelected = selected.length === records.length;
            data = allSelected ? [] : [...records.map(record => record.id)];
        } else {
            data = typeof value === "string" ? value.split(",") : value;
        }

        setSelected(data);
        changeHandler(data);
    };

    React.useEffect(() => {
        setSelected(selectedValues);
    }, [JSON.stringify(selectedValues)]); // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <>
            <MuiCore.FormControl sx={{ m: 1, maxWidth: 100 }}>
                <MuiCore.Select
                    disabled={disabled}
                    open={isOpen}
                    onOpen={() => setIsOpen(true)}
                    onClose={() => setIsOpen(false)}
                    disableUnderline
                    variant='standard'
                    labelId="atsd-multiple-checkbox-label"
                    id="atsd-multiple-checkbox"
                    multiple
                    value={selected}
                    onChange={handleChange}
                    renderValue={(selected: any) => {
                        return showSelectedCount ? `${'(' + selected.length + ')'}` : selected.join(', ')
                    }}
                    MenuProps={{
                        PaperProps: {
                            style: {
                                maxHeight: 'calc(4 * 50px)', // 4 items * item height
                                overflow: 'auto',
                            },
                        },
                    }}
                    onMouseDown={(event) => {
                        if (isLoading || disabled) {
                            event.preventDefault();
                        } else {
                            setIsOpen(true);
                        }
                    }}
                >
                    <MuiCore.MenuItem key={t('FILTER.ALL')} value={t('FILTER.ALL')} style={{
                        maxWidth: 199,
                        height: 46,
                        paddingLeft: 16,
                        paddingRight: 16,
                        alignItems: 'center',
                    }} >
                        <div style={{ display: 'flex', gap: 24, alignItems: 'center' }}>
                            <Checkbox checked={isAllSelected} />
                            <MuiCore.ListItemText style={{ fontWeight: 400, fontSize: 16 }} primary={t('FILTER.ALL')} />
                        </div>
                    </MuiCore.MenuItem>
                    <Divider />
                    {records.map((record) => (
                        <MuiCore.MenuItem key={record.id} value={record.id} style={{
                            display: 'flex',
                            maxWidth: 199,
                            height: 46,
                            paddingLeft: 16,
                            paddingRight: 16,
                            alignItems: 'center',
                        }}>
                            <div style={{ display: 'flex', gap: 24, alignItems: 'center' }}>
                                <Checkbox checked={selected.some((select) => select.toString() === (record.id).toString())} />
                                <MuiCore.ListItemText primary={t(record.name)} style={{ width: 100, fontWeight: 400, fontSize: 16 }} />
                            </div>
                        </MuiCore.MenuItem>
                    ))}
                </MuiCore.Select>
            </MuiCore.FormControl>
        </>
    );
}
